
import { cn } from "@/lib/utils"

function Skeleton({
  className,
  variant = 'default',
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  variant?: 'default' | 'modern' | 'shimmer'
}) {
  const variants = {
    default: "animate-pulse rounded-md bg-muted",
    modern: "animate-pulse rounded-modern bg-gradient-to-r from-muted via-muted/70 to-muted",
    shimmer: "relative overflow-hidden rounded-modern bg-muted before:absolute before:inset-0 before:bg-gradient-to-r before:from-transparent before:via-white/20 before:to-transparent before:animate-shimmer"
  }

  return (
    <div
      className={cn(variants[variant], className)}
      {...props}
    />
  )
}

export { Skeleton }
